import { SELECTION_HIGHLIGHT_COLOR } from '../constants/selection-highlight'
import type { TextOnPathHandleDrag } from '../hooks/use-text-on-path-handle-drag'

interface TextOnPathStartDotProps {
  center: { x: number; y: number }
  radius: number
  /** False when nothing listens for start-distance changes: the dot is then display-only. */
  draggable: boolean
  drag: TextOnPathHandleDrag
}

/** The blue dot marking where the text on a path begins; dragging it moves the start position. */
export function TextOnPathStartDot({ center, radius, draggable, drag }: TextOnPathStartDotProps) {
  return (
    <circle
      cx={center.x}
      cy={center.y}
      r={radius}
      fill={SELECTION_HIGHLIGHT_COLOR}
      stroke="#FFFFFF"
      strokeWidth={1}
      vectorEffect="non-scaling-stroke"
      data-text-on-path-dot="true"
      className="touch-none"
      style={{
        // The shell <svg> is pointerEvents:'none'; opt this one child back in so the dot can be
        // grabbed without making the whole preview hit-testable.
        pointerEvents: draggable ? 'all' : 'none',
        cursor: draggable ? (drag.isDragging ? 'grabbing' : 'grab') : undefined,
      }}
      onPointerDown={drag.onPointerDown}
      onPointerMove={drag.onPointerMove}
      onPointerUp={drag.onPointerUp}
      onPointerCancel={drag.onPointerUp}
    />
  )
}
